import { styled } from "@mui/material";

export const PrivacyPoliciesWrap = styled("div")(() => ({
  padding: "56px 0px",
  backgroundColor: "var(--color-background-primary)",
}));

export const ContentWrap = styled("div")(() => ({
  marginTop: "24px",
  marginBottom: "24px",
  paddingLeft: "24px",

  "& p": {
    fontSize: "var(--font-body-1)",
    marginTop: "16px",
    marginBottom: "16px",
    lineHeight: 1.5,
  },

  "& ul": {
    paddingLeft: "20px",
    marginTop: "16px",
    marginBottom: "16px",
  },

  "& li": {
    fontSize: "var(--font-body-1)",
    marginTop: "8px",
    marginBottom: "8px",
    lineHeight: 1.5,
    color: "var(--color-body-1)",
  },

  "& a": {
    color: "var(--color-primary)",
    textDecoration: "underline",
  },
}));

export const Subtitle = styled("h2")(() => ({
  fontSize: "var(--font-subtitle-1)",
  marginTop: "32px",
  marginBottom: "16px",
}));
